import { render, staticRenderFns } from "./settingsTab.vue?vue&type=template&id=a9fe6f76&"
import script from "./settingsTab.vue?vue&type=script&lang=js&"
export * from "./settingsTab.vue?vue&type=script&lang=js&"
import style0 from "./settingsTab.vue?vue&type=style&index=0&id=a9fe6f76&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports